import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function useRedundancy() {
  const [t] = useTranslation(['projects']);

  const options = useMemo(
    () => [
      { label: 'N', value: 'n' as const },
      { label: 'N+1', value: 'n+1' as const },
      { label: 'N+2', value: 'n+2' as const },
    ],
    [t]
  );

  const kv = useMemo(
    () => options.reduce((map, option) => ({ ...map, [option.value]: option.label }), {}) as Record<string, string>,
    [options]
  );

  const map = useCallback((value?: string | null) => (value ? kv[value] : null), [kv]);

  return { options, kv, map };
}
